
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonClosedBottom as ObiThreewayAcuatorPistonClosedBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-closed-bottom.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonClosedBottom = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-closed-bottom',
   elementClass: ObiThreewayAcuatorPistonClosedBottomElement,
   events: {
     
   }
  });
 
 